
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app
		.constant('ROUTE_ERRORS', {
			auth: 'Authorization has been denied.',
		});
}



// WEBPACK FOOTER //
// ./src/app/core/services/constants.js